import { cn } from '@/lib/cn';

export function Spinner({ className }: { className?: string }) {
  return <span className={cn('inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent', className)} aria-hidden />;
}

export function PageLoader() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center text-brand">
      <Spinner className="size-7" />
    </div>
  );
}
